<template>
  <v-app>
    <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="text-right flex-wrap">
        <v-btn large rounded dark href="javascript:window.print()" class="title mr-2 rounded" color="info">
          <v-icon class="mr-1" color="white" large>mdi-printer</v-icon>พิมพ์
        </v-btn>
        <v-btn @click.stop="Export2Doc('exportContent', 'ใบคะแนนย้ายพนักงานราชการ')" class="mr-1" color="blue">
          <v-icon>mdi-file-word</v-icon>&nbsp; Export to Word
        </v-btn>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items class="d-flex align-center flex-wrap">
        <v-chip
          v-if="candidates.length === 1 && candidates[0].destination_confirmed"
          color="success"
          dark
          small
          class="mx-2"
        >
          <v-icon left small>mdi-check-circle</v-icon>ปลายทางยืนยันแล้วในระบบ
        </v-chip>
        <v-autocomplete
          v-if="candidates.length === 1"
          v-model="selectedDestinationCode"
          :items="colleges"
          item-text="college_name"
          item-value="college_code"
          :label="candidates[0].destination_confirmed ? 'สถานศึกษาปลายทาง (ยืนยันแล้ว)' : 'สถานศึกษาปลายทาง (ถ้าทราบแล้ว) เพื่อคำนวณข้อ 3'"
          dense
          hide-details
          clearable
          style="max-width: 320px"
          class="mx-2"
          @change="onDestinationChange"
        ></v-autocomplete>
        <v-text-field
          v-model="meetingLocation"
          label="สถานที่ประชุม"
          dense
          hide-details
          style="max-width: 260px"
          class="mx-2"
        ></v-text-field>
        <v-text-field
          v-model="meetingDate"
          label="วันที่ประชุม"
          dense
          hide-details
          style="max-width: 180px"
          class="mx-2"
        ></v-text-field>
        <v-text-field
          v-model="assessorName"
          label="ชื่อผู้ประเมิน"
          dense
          hide-details
          style="max-width: 220px"
          class="mx-2"
        ></v-text-field>
        <v-text-field
          v-model="assessorPosition"
          label="ตำแหน่งผู้ประเมิน"
          dense
          hide-details
          style="max-width: 280px"
          class="mx-2"
        ></v-text-field>
      </v-toolbar-items>
    </v-system-bar>

    <v-overlay :value="loading" z-index="9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div id="exportContent">
      <div class="page" v-for="(candidate, idx) in candidates" :key="candidate.id_ref">
        <div class="text-center head">แบบประเมินการย้ายพนักงานราชการทั่วไป</div>
        <div class="text-center regular16">
          การประชุมพิจารณาย้ายพนักงานราชการทั่วไป วันที่ {{ meetingDate }} ณ {{ meetingLocation }}
        </div>

        <table width="100%" class="mt-3">
          <tr>
            <td class="regular16" width="65%">
              ชื่อ-สกุล ผู้รับการประเมิน
              <span class="td_line px-2">{{ candidate.personnel_name }}</span>
            </td>
            <td class="regular16" width="35%">
              ตำแหน่ง
              <span class="td_line px-2">พนักงานราชการทั่วไป</span>
            </td>
          </tr>
          <tr>
            <td class="regular16" colspan="2">
              ปฏิบัติงาน ณ
              <span class="td_line px-2">{{ candidate.college_name_now }}</span>
            </td>
          </tr>
        </table>

        <table width="100%" class="score-table mt-2" border="1" cellspacing="0" cellpadding="4">
          <tr class="bold16 text-center">
            <td width="6%">ที่</td>
            <td width="44%">องค์ประกอบ/ตัวชี้วัด</td>
            <td width="34%">เกณฑ์การพิจารณา</td>
            <td width="8%">คะแนนเต็ม</td>
            <td width="8%">คะแนนที่ได้รับ</td>
          </tr>

          <tr>
            <td class="text-center regular12">1</td>
            <td class="regular12">
              ระยะเวลาการปฏิบัติหน้าที่ในตำแหน่งที่ได้รับการจัดจ้าง (ระยะเวลาการจ้างต่อเนื่อง
              ตั้งแต่สัญญาจ้างพนักงานราชการฉบับแรก จนถึงวันสุดท้ายของการยื่นแบบคำร้องขอย้าย)
            </td>
            <td class="regular12">
              มากกว่า 10 ปี = 20, 5-10 ปี = 15, 2-5 ปี = 10, น้อยกว่า 2 ปี = 5
              <div v-if="candidate.tenure_years !== null" class="blackRegula10">
                (อ้างอิง: ปฏิบัติงานมาแล้ว {{ candidate.tenure_years }} ปี)
              </div>
            </td>
            <td class="text-center regular16">20</td>
            <td class="text-center regular16">
              <span v-if="candidate.score_tenure !== null">{{ candidate.score_tenure }}</span>
              <span v-else class="td_line">&nbsp;&nbsp;&nbsp;</span>
            </td>
          </tr>

          <tr>
            <td class="text-center regular12">2</td>
            <td class="regular12">เหตุผลในการขอย้าย</td>
            <td class="regular12">
              อยู่ร่วมกับคู่สมรส/บุตร, ดูแลบิดามารดา, กลับภูมิลำเนา, เหตุผลอื่นๆ (ข้อละ 5 คะแนน)
            </td>
            <td class="text-center regular16">20</td>
            <td class="text-center regular16">
              <span v-if="candidate.score_reason !== null">{{ candidate.score_reason }}</span>
              <span v-else class="td_line">&nbsp;&nbsp;&nbsp;</span>
            </td>
          </tr>

          <tr>
            <td class="text-center regular12">3</td>
            <td class="regular12">ระยะทางในการขอย้าย</td>
            <td class="regular12">
              ย้ายต่างภูมิภาค = 15, ย้ายต่างจังหวัดในภูมิภาคเดียวกัน = 10, ย้ายภายในจังหวัดเดียวกัน = 5
              <div v-if="candidate.distance_label" class="blackRegula10">
                (อ้างอิง: {{ candidate.distance_label }}<span v-if="candidate.distance_km !== null">
                  ~{{ candidate.distance_km }} กม.</span>)
              </div>
            </td>
            <td class="text-center regular16">15</td>
            <td class="text-center regular16">
              <span v-if="candidate.score_distance !== null">{{ candidate.score_distance }}</span>
              <span v-else class="td_line">&nbsp;&nbsp;&nbsp;</span>
            </td>
          </tr>

          <tr>
            <td class="text-center regular12">4</td>
            <td class="regular12">
              ประวัติการปฏิบัติงาน และผลงานดีเด่นจากการปฏิบัติงาน จำนวน 1 เรื่อง ไม่เกิน 1 หน้ากระดาษ A4
            </td>
            <td class="regular12">ให้อยู่ในดุลพินิจของคณะกรรมการฯ</td>
            <td class="text-center regular16">30</td>
            <td class="text-center regular16"><span class="td_line">&nbsp;&nbsp;&nbsp;</span></td>
          </tr>

          <tr>
            <td class="text-center regular12">5</td>
            <td class="regular12">การประเมินผลการปฏิบัติงาน</td>
            <td class="regular12">
              ดีเด่น (95-100) = 15, ดีมาก (85-94) = 10, ดี (75-84) = 5
              <div v-if="candidate.performance_total_score !== null" class="blackRegula10">
                (อ้างอิง: ผลประเมินล่าสุด {{ candidate.performance_total_score }} คะแนน)
              </div>
            </td>
            <td class="text-center regular16">15</td>
            <td class="text-center regular16">
              <span v-if="candidate.score_performance !== null">{{ candidate.score_performance }}</span>
              <span v-else class="td_line">&nbsp;&nbsp;&nbsp;</span>
            </td>
          </tr>

          <tr class="bold16">
            <td colspan="3" class="text-right">รวม</td>
            <td class="text-center">100</td>
            <td class="text-center"><span class="td_line">&nbsp;&nbsp;&nbsp;</span></td>
          </tr>
        </table>

        <div class="regular12 mt-1">
          หมายเหตุ: ผู้ผ่านการประเมินต้องได้คะแนนไม่น้อยกว่าร้อยละ 60 (60 คะแนน) — คะแนนข้อ 1, 2 และ 5
          คำนวณโดยระบบจากข้อมูลที่บันทึกไว้ในระบบโดยอัตโนมัติ เพื่อใช้เป็นข้อมูลประกอบการพิจารณาเบื้องต้น
          ส่วนข้อ 3 (ระยะทาง) ระบบคำนวณให้อัตโนมัติเมื่อบันทึกปลายทางผ่านหน้า "เลือกตำแหน่งลงบรรจุ" แล้ว
          หรือเลือกดูตัวอย่างล่วงหน้าได้จากช่อง "สถานศึกษาปลายทาง" ด้านบน (ระยะทางเป็นกิโลเมตรเป็น
          ข้อมูลอ้างอิงโดยประมาณจากพิกัดศูนย์กลางจังหวัด ไม่ใช่เกณฑ์ตัดสินคะแนนโดยตรง)
          คณะกรรมการสามารถปรับแก้ไขคะแนนทุกข้อได้ตามดุลยพินิจ
          ส่วนข้อ 4 (ประวัติ/ผลงานดีเด่น) ให้คณะกรรมการเป็นผู้พิจารณาให้คะแนนในที่ประชุมเสมอ
        </div>

        <table width="100%" class="mt-4">
          <tr>
            <td class="regular16">
              &#9744; ผ่านการประเมิน ย้ายไป
              <span class="td_line px-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </td>
          </tr>
          <tr>
            <td class="regular16">
              &#9744; ไม่ผ่านการประเมิน
              <span class="td_line px-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </td>
          </tr>
        </table>

        <table width="100%" class="mt-4">
          <tr>
            <td width="60%"></td>
            <td width="40%" class="text-center regular16">
              (ลงชื่อ) ................................................ ผู้ประเมิน<br />
              ( {{ assessorName }} )<br />
              {{ assessorPosition }}<br />
              วันที่ {{ meetingDate }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "PrintGovemTransferScore",
  data: () => ({
    ApiKey: "HRvec2021",
    loading: false,
    candidates: [],
    colleges: [],
    selectedDestinationCode: null,
    meetingLocation: "ห้องประชุม 1 ชั้น 2 สำนักงานคณะกรรมการการอาชีวศึกษา",
    meetingDate: "",
    assessorName: "นายณรงค์ชัย เจริญรุจิทรัพย์",
    assessorPosition: "รองเลขาธิการคณะกรรมการการอาชีวศึกษา ประธานกรรมการ"
  }),

  async mounted() {
    await this.loadCandidates();
    this.loadColleges();
  },

  methods: {
    async loadColleges() {
      try {
        const result = await this.$http.post("college.php", { ApiKey: this.ApiKey });
        this.colleges = result.data || [];
      } catch (error) {
        // ไม่ต้อง block การพิมพ์ถ้าโหลดรายชื่อสถานศึกษาไม่สำเร็จ — แค่ใช้เลือกปลายทางไม่ได้
      }
    },

    async onDestinationChange(collegeCode) {
      if (!this.candidates.length) return;
      const id_ref = this.candidates[0].id_ref;
      this.loading = true;
      try {
        const result = await this.$http.post("gov_em_transfer_score.php", {
          ApiKey: this.ApiKey,
          id_ref,
          college_code_to: collegeCode || undefined
        });
        if (result.data && result.data.status) {
          this.candidates = [result.data.data];
        }
      } catch (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถคำนวณระยะทางได้", "error");
      } finally {
        this.loading = false;
      }
    },

    async loadCandidates() {
      this.loading = true;
      try {
        const q = this.$route.query;
        let result;
        if (q.rounds) {
          // rounds = "time_s:year_s,time_s:year_s,..." — เรียก batch ต่อรอบ ไม่ยิงทีละคน
          const roundPairs = q.rounds.split(",").map(r => r.split(":"));
          const responses = await Promise.all(
            roundPairs.map(([time_s, year_s]) =>
              this.$http.post("gov_em_transfer_score.php", {
                ApiKey: this.ApiKey,
                time_s,
                year_s
              })
            )
          );
          this.candidates = responses
            .filter(r => r.data && r.data.status)
            .reduce((acc, r) => acc.concat(r.data.data), []);
        } else if (q.id_refs) {
          const ids = q.id_refs.split(",");
          const responses = await Promise.all(
            ids.map(id_ref =>
              this.$http.post("gov_em_transfer_score.php", {
                ApiKey: this.ApiKey,
                id_ref
              })
            )
          );
          this.candidates = responses
            .map(r => r.data && r.data.status ? r.data.data : null)
            .filter(c => c);
        } else if (q.id_ref) {
          result = await this.$http.post("gov_em_transfer_score.php", {
            ApiKey: this.ApiKey,
            id_ref: q.id_ref
          });
          this.candidates = result.data && result.data.status ? [result.data.data] : [];
        } else if (q.time_s && q.year_s) {
          result = await this.$http.post("gov_em_transfer_score.php", {
            ApiKey: this.ApiKey,
            time_s: q.time_s,
            year_s: q.year_s
          });
          this.candidates = result.data && result.data.status ? result.data.data : [];
        }
        // ถ้าเหลือผู้สมัครรายเดียวและมีปลายทางยืนยันแล้วในระบบ ให้ช่อง "สถานศึกษาปลายทาง" แสดงค่านั้น
        // ให้ตรงกับที่ backend คำนวณให้อัตโนมัติ (ไม่ใช่แค่คำนวณเงียบๆ โดยไม่แสดงในตัวเลือก)
        if (this.candidates.length === 1 && this.candidates[0].college_code_to) {
          this.selectedDestinationCode = this.candidates[0].college_code_to;
        }
      } catch (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลคะแนนได้", "error");
      } finally {
        this.loading = false;
      }
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html = preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["﻿", html], { type: "application/msword" });
      var url = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);
      filename = filename ? filename + ".doc" : "document.doc";

      var downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    }
  }
};
</script>

<style scoped>
.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin: 0.5cm auto;
  padding: 1cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 20pt;
  font-weight: bold;
  line-height: 1.4;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
  color: #555;
}

.td_line {
  border-bottom: 1pt dotted black;
}

.score-table {
  border-collapse: collapse;
}

.score-table td {
  border: 1px solid #333;
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    margin: 0;
    page-break-after: always;
  }
}
</style>
